<template>

    <div v-if="isVisible" class="modal-overlay modal">
        <div class="modal-content w-50 p-0">

            <form @submit.prevent="addUser()">
                <div class="modal-header p-3">
                    <h5 class="mb-0">Adicionar Usuário</h5>
                    <i class="ri-close-line cursor-pointer" @click="closeModal"></i>
                </div>

                <div class="modal-body p-3">
                    
                    <div class="mb-3 d-flex gap-2">

                        <div class="flex-1">
                            <InputField 
                            :required="true" 
                            label="Nome *" 
                            type="text" 
                            placeHolder="Digite aqui o nome do usuário ..."
                            v-model="newUser.nome"
                            />
                        </div>

                        <div v-if="authStore.usuario.root" class="flex-1">
                            <SelectField
                            label="Parceria *"
                            labelOption="nome"
                            :options="getParcerias()"
                            placeHolder="Escolha uma parceria *"
                            valueProp="id"
                            :canClear="false"
                            v-model="newUser.parceriaId"
                            />
                        </div>

                    </div>
                    
                    <div class="mb-3 d-flex gap-2" >

                        <div class="flex-1">
                            <InputField 
                            :required="true" 
                            label="Email *" 
                            type="email" 
                            placeHolder="example@gmail.com"
                            v-model="newUser.email"
                            />
                        </div>

                        <div v-if="authStore.usuario.root" class="flex-1">
                            <SelectField classLabel="form-label" label="Root *" labelOption="name"
                                :options="[{value:0,name:'Não'},{value:1,name:'Sim'}]" placeHolder="Usuário será root?" valueProp="value"
                                :canClear="false" v-model="newUser.root" :required="true"/>
                        </div>
                        
                    </div>

                    <div class="mb-2 d-flex gap-2">

                        <div class="flex-1">
                            <InputField 
                            :required="true" 
                            label="Senha *" 
                            type="password" 
                            placeHolder="Digite aqui a senha de acesso ..."
                            v-model="newUser.senha"
                            />
                        </div>

                        <div class="flex-1">
                            <InputField 
                            :required="true" 
                            label="Confirmar Senha *" 
                            type="password" 
                            placeHolder="Digite aqui sua senha de acesso para confirmar ..."
                            v-model="confirmarSenha"
                            />
                        </div>

                    </div>

                    <div>
                        
                        <ul class="p-0">

                            <li :class="{'text-success' : verificarSegurançaSenha().etapa1, 'text-danger': !verificarSegurançaSenha().etapa1 }">

                                <template v-if="verificarSegurançaSenha().etapa1">
                                    <i class="ri-checkbox-circle-line"></i>
                                </template>
                                <template v-else>
                                    <i class="ri-close-circle-line"></i>
                                </template>
                                     
                                Pelo menos 1 letra maiúscula e 1 letra minúscula
                            </li>

                            <li :class="{'text-success' : verificarSegurançaSenha().etapa2, 'text-danger': !verificarSegurançaSenha().etapa2 }">

                                <template v-if="verificarSegurançaSenha().etapa2">
                                    <i class="ri-checkbox-circle-line"></i>
                                </template>
                                <template v-else>
                                    <i class="ri-close-circle-line"></i>
                                </template>

                                Pelo menos 1 número
                            </li>

                            <li :class="{'text-success' : verificarSegurançaSenha().etapa3, 'text-danger': !verificarSegurançaSenha().etapa3 }">

                                <template v-if="verificarSegurançaSenha().etapa3">
                                    <i class="ri-checkbox-circle-line"></i>
                                </template>
                                <template v-else>
                                    <i class="ri-close-circle-line"></i>
                                </template>

                                Pelo menos 1 caracter especial
                            </li>

                            <li :class="{'text-success' : verificarSegurançaSenha().etapa4, 'text-danger': !verificarSegurançaSenha().etapa4 }">

                                <template v-if="verificarSegurançaSenha().etapa4">
                                    <i class="ri-checkbox-circle-line"></i>
                                </template>
                                <template v-else>
                                    <i class="ri-close-circle-line"></i>
                                </template>

                                Pelo menos 8 caracteres
                            </li>

                            <li :class="{'text-success' : verificarSegurançaSenha().etapa5, 'text-danger': !verificarSegurançaSenha().etapa5 }">

                                <template v-if="verificarSegurançaSenha().etapa5">
                                    <i class="ri-checkbox-circle-line"></i>
                                </template>
                                <template v-else>
                                    <i class="ri-close-circle-line"></i>
                                </template>

                                As senhas devem ser iguais
                            </li>

                        </ul>
                
                    </div>


                </div>

                <div class="modal-footer p-3">

                    <ButtonField @click="closeModal" size="small" text="Fechar" type="light"></ButtonField>

                    <ButtonField size="small" text="Adicionar" type="success" :submit="true" :isLoading="isLoading" :disabled="!verificaCriteriosSenha()" :loadingText="'Criando usuário'"></ButtonField>

                </div>
            </form>

        </div>
    </div>

</template>

<script>
    import { useUsuariosStore } from '@/stores/usuarios';
    import { useParceriasStore } from '@/stores/parcerias.js';
    import { useAuthStore } from '@/stores/auth.js';

    import { toast } from 'vue3-toastify'

    const defaultUser = {nome: '', email: '', senha: '', parceriaId: '', root: 0}

    export default{
        props:{
            isVisible : {
                type : Boolean,
                default: false
            },
        },
        emits:['close'],
        data(){
            return{
                usuariosStore : useUsuariosStore(),
                newUser: {...defaultUser},
                confirmarSenha: '',
                isLoading: false,
                parceriasStore: useParceriasStore(),
                authStore: useAuthStore()
            }
        },
        methods:{

            verificarSegurançaSenha(){

                const regex1 = /^(?=.*[a-z])(?=.*[A-Z])/;
                const etapa1 = regex1.test(this.newUser.senha);
                
                const regex2 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/;
                const etapa2 = regex2.test(this.newUser.senha);
                
                const regex3 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])/;
                const etapa3 =  regex3.test(this.newUser.senha);
                
                const regex4 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
                const etapa4 = regex4.test(this.newUser.senha);

                const etapa5 = (this.newUser.senha == this.confirmarSenha)

                return {etapa1, etapa2, etapa3, etapa4, etapa5}

            },

            verificaCriteriosSenha(){
                const etapas = this.verificarSegurançaSenha()
                return (etapas.etapa1 && etapas.etapa2 && etapas.etapa3 && etapas.etapa4 && etapas.etapa5)
            },

            closeModal(){
                this.$emit('close');
            },
            async addUser(){

                this.isLoading = true

                if (!this.newUser.parceriaId) delete this.newUser.parceriaId;

                const newUser = {...this.newUser}

                if(!this.authStore.usuario.root){
                    alert
                    delete newUser.root
                }else{
                    newUser.root = (newUser.root) ? true : false
                }

            

                const result = await this.usuariosStore.add(newUser)
                
                this.isLoading = false

                if(result.status){
                    toast.success("Usuário adicionado com sucesso")
                    this.closeModal()
                    this.newUser = {...defaultUser}
                    this.usuariosStore.get()
                }else{
                    toast.error(result.message)
                }

            },
            getParcerias(){
                const parcerias = this.parceriasStore.parcerias.filter(p => p.id != '')
                parcerias.unshift({id:'',nome:'Nenhuma'})
                return parcerias
            }
        },
        mounted() {
            if(this.authStore.usuario.root)
            {
                this.parceriasStore.get()
            }
        }
    }
</script>